import React, { createContext, useContext, useState, useCallback } from "react";

const DonateContext = createContext(null);

export const DonateProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [initialAmount, setInitialAmount] = useState(null);

  const openDonate = useCallback((amount = null) => {
    setInitialAmount(amount);
    setOpen(true);
  }, []);

  return (
    <DonateContext.Provider value={{ open, setOpen, openDonate, initialAmount }}>
      {children}
    </DonateContext.Provider>
  );
};

export const useDonate = () => useContext(DonateContext);
